export function isSentryEnabledClient(): boolean {
  // Only VITE_* env vars are available in the browser bundle.
  return (
    import.meta.env.VITE_SENTRY_ENABLED === "true" &&
    typeof import.meta.env.VITE_SENTRY_DSN === "string" &&
    import.meta.env.VITE_SENTRY_DSN.length > 0
  );
}

